import React, { type ReactNode, type ComponentType } from 'react';
import type { WrapperProps } from '../../common/types.tsx';

export type ConditionalNudgeWrapperProps = {
	children: ReactNode;
	Wrapper: ComponentType<WrapperProps>;
	conditionsToApplyWrapper: boolean;
} & Partial<
	Flow.Diff<
		WrapperProps,
		{
			children: ReactNode;
		}
	>
>;

export const ConditionalNudgeWrapper = ({
	children,
	Wrapper,
	conditionsToApplyWrapper,
	...restProps
}: ConditionalNudgeWrapperProps) => {
	if (conditionsToApplyWrapper && !__SERVER__ && children !== null && children !== false) {
		return <Wrapper {...restProps}>{children}</Wrapper>;
	}
	return <>{children}</>;
};
